"use strict";

exports.__esModule = true;
exports.default = useQuery;

var _useQueryBase = _interopRequireDefault(require("./useQueryBase"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} // the useQuery with the API I like


function useQuery(passedOptions) {
  var options = _extends({
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    notifyOnNetworkStatusChange: false
  }, passedOptions);

  var result = (0, _useQueryBase.default)(options);
  return _extends({}, result.data, result);
}